/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

import { CircularProgress, Stack } from '@mui/material';
import { useQueries } from '@tanstack/react-query';

import { formatPara } from './helper';
import Insights from './Insights';
import Issues from './Issues';
import { getInsights } from '../../axiosClient/draftApi';

interface IProps {
  activeTab: string;
  id?: string;
  sections?: any;
}

const SectionList = (props: IProps) => {
  const { sections, id, activeTab } = props;

  const combinedQueries = useQueries({
    queries:
      sections && id
        ? sections.map((data: any) => {
            return {
              queryKey: ['insights-list', data.id, id],
              queryFn: () => getInsights(id, data.id),
            };
          })
        : [],
    combine: (results) => {
      return {
        data: results.map((result) => {
          const newResult: any = result.data as any[];
          if (newResult) {
            let content1: any[] = [];
            let content2: any[] = [];
            newResult.q1_content?.map((content: any) => {
              if (content?.answer) {
                content1 = [...content1, ...content.answer.split('\n')];
              }
            });
            newResult.q2_content?.map((content: any) => {
              if (content?.answer) {
                content2 = [...content2, ...content.answer.split('\n')];
              }
            });
            const shortedContent1 = content1.filter((data) => {
              const para = formatPara(data);
              return (
                para !== '' &&
                para?.toLowerCase() !== 'not found' &&
                para?.toLowerCase() !== 'not found.'
              );
            });
            const shortedContent2 = content2.filter((data) => {
              const para = formatPara(data);
              return (
                para !== '' &&
                para?.toLowerCase() !== 'not found' &&
                para?.toLowerCase() !== 'not found.'
              );
            });
            newResult.insights = [...shortedContent1];
            newResult.issues = [...shortedContent2];
          }
          return newResult;
        }),
        pending: results.some((result) => result.isPending),
      };
    },
  });

  return (
    <>
      {combinedQueries.pending ? (
        <Stack style={{ padding: '5px' }}>
          <CircularProgress />
        </Stack>
      ) : (
        <>
          {activeTab === 'insights' && <Insights insights={combinedQueries} />}
          {activeTab === 'issues' && <Issues issues={combinedQueries} />}
        </>
      )}
    </>
  );
};

export default SectionList;
